import { AdmissionGroupType } from '../constants/admissionGroup'

export type SubstatusConfigKey =
  | 'reservationSubstatuses'
  | 'admissionSubstatuses'

type SubstatusVenueConfig = {
  reservationSubstatuses?: string[] | null
  admissionSubstatuses?: string[] | null
}

const SUBSTATUS_CONFIG_KEY_BY_TYPE: Record<
  AdmissionGroupType,
  SubstatusConfigKey
> = {
  [AdmissionGroupType.TABLE]: 'reservationSubstatuses',
  [AdmissionGroupType.GUEST_LIST]: 'admissionSubstatuses',
  [AdmissionGroupType.TICKET]: 'admissionSubstatuses',
  [AdmissionGroupType.TALLY]: 'admissionSubstatuses',
}

export function getSubstatusConfigKey(
  type: AdmissionGroupType
): SubstatusConfigKey {
  return SUBSTATUS_CONFIG_KEY_BY_TYPE[type]
}

export function getConfiguredSubstatuses(
  config: SubstatusVenueConfig | null | undefined,
  type: AdmissionGroupType
): string[] {
  if (!config) return []

  return config[getSubstatusConfigKey(type)] ?? []
}
